<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('externalUser.production.payment') }}</h4>
      </template>
      <template v-slot:body>
         <b-row>
           <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                  <b-form-group
                      class="row"
                      label-cols-sm="4"
                      label-for="date_form"
                  >
                      <template v-slot:label>
                          {{$t('globalTrans.from_date')}}
                      </template>
                      <b-form-input class="form-control"
                          v-model="search.date_form"
                          placeholder="Select Date"
                          id="date_form"
                      ></b-form-input>
                  </b-form-group>
            </b-col>
            <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                  <b-form-group
                      class="row"
                      label-cols-sm="4"
                      label-for="to_date"
                  >
                      <template v-slot:label>
                          {{$t('globalTrans.to_date')}}
                      </template>
                      <b-form-input class="form-control"
                          v-model="search.to_date"
                          placeholder="Select Date"
                          id="to_date"
                      ></b-form-input>
                  </b-form-group>
            </b-col>
            <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                  <b-form-group
                      class="row"
                      label-cols-sm="4"
                      label-for="receive_date"
                  >
                      <template v-slot:label>
                          {{$t('retailerManagement.receive_date')}}
                      </template>
                      <b-form-input class="form-control"
                          v-model="search.receive_date"
                          placeholder="Select Date"
                          id="receive_date"
                      ></b-form-input>
                  </b-form-group>
            </b-col>
            <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                  <b-form-group
                      class="row"
                      label-cols-sm="4"
                      label-for="receive_id"
                  >
                      <template v-slot:label>
                          {{$t('externalUser.production.receive_id')}}
                      </template>
                      <b-form-input class="form-control"
                          v-model="search.receive_id"
                          id="receive_id"
                      ></b-form-input>
                  </b-form-group>
            </b-col>
            <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                  <b-form-group
                      class="row"
                      label-cols-sm="4"
                      label-for="delivery_order_id"
                  >
                      <template v-slot:label>
                          {{$t('retailerManagement.delivery_order_id')}}
                      </template>
                      <b-form-input class="form-control"
                          v-model="search.delivery_order_id"
                          id="delivery_order_id"
                      ></b-form-input>
                  </b-form-group>
            </b-col>
            <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                  <b-form-group
                      class="row"
                      label-cols-sm="4"
                      label-for="voucher_no"
                  >
                      <template v-slot:label>
                          {{$t('externalUser.voucher_no')}}
                      </template>
                      <b-form-input class="form-control"
                          v-model="search.voucher_no"
                          id="voucher_no"
                      ></b-form-input>
                  </b-form-group>
            </b-col>
            <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                  <b-form-group
                      class="row"
                      label-cols-sm="4"
                      label-for="transaction_no"
                  >
                      <template v-slot:label>
                          {{$t('externalUser.transaction_no')}}
                      </template>
                      <b-form-input class="form-control"
                          v-model="search.transaction_no"
                          id="transaction_no"
                      ></b-form-input>
                  </b-form-group>
            </b-col>
            <b-col xs="12" sm="12" md="6" lg="6" xl="4">
              <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search') }}</b-button>
            </b-col>
        </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('externalUser.production.payment_list') }}</h4>
          </template>
          <template v-slot:headerAction>
            <b-button variant="primary" v-b-modal.modal-payment @click="resetId">
                {{  $t('globalTrans.add_new') }}
            </b-button>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(pay_status)="data">
                        <span :class="(data.item.pay_status === 'success') ? `badge badge-success` : `badge badge-danger`">{{ data.item.pay_status }}</span>
                    </template>
                    <template v-slot:cell(receive_id)="data">
                          {{ data.item.delivery_rec_main?.receive_id }}
                    </template>
                    <template v-slot:cell(created_at)="data">
                          {{ data.item.created_at | dateFormat }}
                    </template>
                   <template v-slot:cell(action)="data">
                     <span class="d-flex">
                      <b-button class="mr-1" :title="$t('globalTrans.details')" v-b-modal.modal-detail variant="iq-bg-info border-info" size="sm" @click="details(data.item)"><i class="ri-eye-line m-0 "></i></b-button>
                      <b-button v-if="data.item.payment_type_id === 1 && data.item.pay_status === 'pending'" class="mr-2 blink_me btn btn-warning btn-sm" :title="$t('externalUser.order_payment')" size="sm" @click="pendingPayment(data.item)">{{ $t('globalTrans.payment') }}</b-button>
                     </span>
                  </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-detail" size="lg" :title="$t('externalUser.payment_details')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <DetailModal :id="editItemId"/>
    </b-modal>
    <b-modal id="modal-payment" size="lg" :title="$t('externalUser.order_payment')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <Payment />
    </b-modal>
  </b-container>
</template>
<script>
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { Paymentlist } from '../../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import DetailModal from './DetailModal'
import Payment from './addPayment'
import flatpickr from 'flatpickr'
export default {
  mixins: [ModalBaseMasterList],
   components: {
    DetailModal,
    Payment
  },
  data () {
    return {
      search: {
        is_user: 1,
        date_form: '',
        to_date: '',
        receive_date: '',
        receive_id: '',
        delivery_order_id: '',
        transaction_no: '',
        voucher_no: ''
      },
      editItemId: ''
    }
  },
  computed: {
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
          { label: this.$t('externalUser.production.receive_id'), class: 'text-left' },
          { label: this.$t('externalUser.voucher_no'), class: 'text-left' },
          { label: this.$t('externalUser.amount'), class: 'text-left' },
          { label: this.$t('externalUser.payment_date'), class: 'text-left' },
          { label: this.$t('externalUser.transaction_no'), class: 'text-left' },
          { label: this.$t('globalTrans.status'), class: 'text-center' },
          { label: this.$t('globalTrans.action'), class: 'text-center' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'receive_id' },
          { key: 'voucher_no' },
          { key: 'amount' },
          { key: 'created_at' },
          { key: 'transaction_no' },
          { key: 'pay_status' },
          { key: 'action' }
        ]
      } else {
        keys = [
         { key: 'index' },
          { key: 'receive_id' },
          { key: 'voucher_no' },
          { key: 'amount' },
          { key: 'created_at' },
          { key: 'transaction_no' },
          { key: 'pay_status' },
          { key: 'action' }
        ]
      }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    }
  },
  created () {
    this.loadData()
    this.paymentStatusUpdate()
  },
  mounted () {
     flatpickr('#date_form', {})
     flatpickr('#to_date', {})
     flatpickr('#receive_date', {})
  },
  methods: {
    details (item) {
      this.editItemId = item.id
    },
    searchData () {
      this.loadData()
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(productionServiceBaseUrl, Paymentlist, params).then(response => {
          if (response.success) {
            this.$store.dispatch('setList', response.data.data)
            this.paginationData(response.data)
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    getPaymentStatus (status) {
        const Status = this.$store.state.ExternalUser.commonObj.paymentStatusList.find(item => item.value === status)
        if (this.$i18n.locale === 'bn') {
            return Status.text_bn
        } else {
            return Status.text_en
        }
    },
    async paymentStatusUpdate () {
        if (this.$route.params.status && this.$route.query.transId) {
            const status = this.$route.params.status
            const tranId = this.$route.query.transId
            this.$bvModal.show('modal-processing')
            await RestApi.getData(productionServiceBaseUrl, '/order/payment/' + status, { transId: tranId }).then(response => {
            this.$bvModal.hide('modal-processing')
            if (response.success) {
              if (response.notification && this.$store.state.emitNotification) {
                const notification = response.notification
                this.$socket.emit('send-notification', notification)
              }
                this.$toast.success({
                title: 'Success',
                message: response.message,
                color: '#D6E09B'
                })
                this.loadData()
            } else {
                this.$toast.error({
                title: 'Error',
                message: response.message
                })
            }
            })
            this.$router.push('/dealer-panel/payment')
        }
    },
    async pendingPayment (item) {
      const myData = {
        id: item.id,
        delivery_order_id: item.delivery_order_id,
        amount: item.amount
      }
      var message = this.$t('globalTrans.surePay')
      this.confirmationPopup(message, (response) => {
        if (response === true) {
            this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
            RestApi.getData(productionServiceBaseUrl, '/order/payment/pending-payment', myData).then(response => {
              if (response.success === true) {
                  this.$toast.success({
                      title: this.$t('globalTrans.success'),
                      message: this.$t('globalTrans.update_msg'),
                      color: '#D6E09B'
                  })
                  window.location = response.url
              } else {
                this.$toast.error({
                  title: this.$t('globalTrans.error'),
                      message: this.$t('globalTrans.operationFailed')
                  })
              }
              this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: true })
          })
        }
      })
    }
  }
}
</script>
<style scope='css'>
  .blink_me {
    animation: blinker 1.3s linear infinite;
    color: red;
  }
  @keyframes blinker {
    50% {
      opacity: .09;
      background-color: green;
    }
  }
</style>
